export enum CustomNode {
  WEIGHTED_ATTRIBUTE = "WEIGHTED_ATTRIBUTE",
  OPTION = "OPTION",
  RESULT = "RESULT",
}
